<template>
  <div class="ti-page-start py2">
    <div class="lg-section px2">
      <router-link :to="{name: 'vendor-list'}" class="ti-link">🡸 Vendors</router-link>
    </div>
    <div v-if="!loading && !error" class="flex lg-section px2">
      <h2 class="detail-header-title inline flex-auto">{{vendor.name}}</h2>
      <div v-if="vendor.connect" style="text-align:right;">
        <router-link :to="{name: 'connect-detail',
                           params: {id: vendor.id, slug:toSlug(vendor.name)}}"
                     class="ti-link">
          <img v-if="vendor.connectLogo" :alt="vendor.name"
               :src="vendor.connectLogo" style="width:100px;height:auto; margin:3px;"/>
          <span v-else>{{vendor.name}}</span>
          <div>Vendor Connect ➜</div>
        </router-link>
      </div>
    </div>

    <div v-if="!loading && error" class="lg-section px2 pt2">
      <p>{{error}}</p>
    </div>
    <div v-else-if="!loading && !user.canAccess" class="lg-section ml3">
      <div class="py3">
        <span class="ti-message ti-message-alert">
          Access to this page is not currently included in your subscription.
          See <a href="/profile" class="ti-link">profile</a> page for details.
        </span>
      </div>
      <p v-if="!user.authenticated">
        <a href="/login" class="ti-link">Log in</a> or
        <a href="/signup" class="ti-link">sign up</a>
        to a free <strong>ESSENTIAL</strong> subscription to access.
      </p>
    </div>

    <div v-if="!loading && !error && user.canAccess" class="lg-section px2 flex">
      <div class="sm-col md-col-4 px2 pb2">
        <table class="ti-tblf mt3">
          <tr>
            <th colspan="2" class="ti-tblf-header"
                style="background:#FDC833;opacity:0.7;">
              Verticals
            </th>
          </tr>
          <tr v-for="code in $store.state.refMap.vertical_items" :key="code"
              class="ti-tblf-row"
              :class="{'ti-tblf-row-highlight': hasVertical(code)}">
            <th>{{$store.state.refMap.verticals[code].label}}</th>
            <td><span v-if="hasVertical(code)" class="ti-tblf-val"
                      style="font-weight:bold;font-size:16px;">✓</span>
            </td>
          </tr>
        </table>
      </div>

      <div class="sm-col md-col-8 px2">
        <div v-if="vendor.view">
          <h3 class="detail-prop-title">Our View</h3>
          <p class="ti-p">{{vendor.view}}</p>
        </div>


        <div>
          <h3 class="detail-prop-title">
            {{vendor.name}} capabilities in Digital Transformation
          </h3>
          <div v-if="Object.entries(vendor.technologies).length">
            <table class="ti-tbl2">
              <thead>
                <tr class="ti-tbl-light sticky-header">
                  <th class="ti-tbl2-header" style="text-align:left;">
                    Capability
                  </th>
                  <th class="ti-tbl2-header" style="padding-left:12px;padding-right:12px">
                    None</th>
                  <th class="ti-tbl2-header" style="padding-left:12px;padding-right:12px">
                    Emerging</th>
                  <th class="ti-tbl2-header" style="padding-left:12px;padding-right:12px">
                    Significant</th>
                  <th class="ti-tbl2-header" style="padding-left:12px;padding-right:12px">
                    Market Leading</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="area in vendor.technologies">
                  <tr :key="area.code" class="ti-tbl-tech">
                    <th class="ti-tbl2-header"
                        style="font-weight:bold;text-align:left;">
                      {{area.label}}
                    </th>
                    <template v-if="area.isAccessible && area.isNone">
                      <td class="ti-tbl2-val">✓</td>
                      <td colspan="3"></td>
                    </template>
                    <template v-else>
                      <td colspan="4">
                        <span v-if="!area.isAccessible" class="ti-note">
                          Not accessible
                        </span>
                      </td>
                    </template>
                  </tr>
                  <template v-if="!area.isNone && area.isAccessible">
                    <template v-for="role in area.roles">
                      <tr :key="area.code + role.id" v-if="role.isNone">
                        <th class="ti-tbl2-header vendor-role-label" :title="role.def">
                          {{role.label}}
                        </th>
                        <td class="ti-tbl2-val" style="border-top: 1px solid #E5E5E5;">✓</td>
                        <td colspan="3" style="border-top: 1px solid #E5E5E5;"></td>
                      </tr>
                      <template v-if="!role.isNone">
                        <tr v-for="tech in role.items" :key="tech.id" class="ti-tbl2-row">
                          <th><a target="_blank" :title="tech.def">
                              <!-- <a href="{{ url_for('capability', tech_id=tech.id) }}" -->
                              {{tech.label}}
                          </a></th>
                          <td v-for="level in [1,2,3,4]" :key="level" class="ti-tbl2-val">
                            <span v-if="tech.level==level">
                              <span v-if="level!=1 && !tech.monetised">(✓)</span>
                              <span v-else>✓</span>
                                <span v-if="tech.sub!=0"
                                     style="font-size:10px; vertical-align:super;">
                                <span v-if="tech.sub>0">*</span>
                                <span v-else>†</span>
                              </span>
                              <span v-else>&nbsp;
                              </span>
                            </span>
                          </td>
                        </tr>
                      </template>
                  </template></template>
                </template>
              </tbody>
            </table>
            <p class="ti-p right" style="font-size:12px;">
              <span><span class="bold">() </span>Not monetised;</span>
              &nbsp;<span><span class="bold">* </span>From subsidiary;</span>
              &nbsp;<span><span class="bold">† </span>From parent</span>
            </p>
          </div>
          <p v-else class="ti-p">No capability registered for this Vendor</p>
        </div>

        <div v-if="vendor.parents.length">
          <h3 class="detail-prop-title">
            Parent
            <span v-if="vendor.parents.length>1">Companies</span>
            <span v-else>Company</span>
          </h3>
          <ul><li v-for="parent in vendor.parents" :key="parent.id" class="ti-p">
              <router-link :to="{name: 'vendor-detail',
                                params: {id: parent.id, slug:toSlug(parent.name)}}"
                           class="ti-link">
                {{parent.name}}
              </router-link>
          </li></ul>
        </div>

        <div v-if="vendor.children.length">
          <h3 class="detail-prop-title">
            <span v-if="vendor.parents.length>1">Subsidiaries</span><span v-else>Subsidiary</span>
          </h3>
          <ul><li v-for="child in vendor.children" :key="child.id" class="ti-p">
              <router-link :to="{name: 'vendor-detail',
                                params: {id: child.id, slug:toSlug(child.name)}}"
                           class="ti-link">
                {{child.name}}
              </router-link>
          </li></ul>
        </div>

        <div v-if="vendor.studies.length">
          <h3 class="detail-prop-title">Available Case Studies</h3>
          <ul><li v-for="cs in vendor.studies" :key="cs.id" class="ti-p mb1">
              <a :href="'/research/database/' + cs.id" class="ti-link">
                {{cs.title}}
              </a>
          </li></ul>
        </div>

        <div v-if="vendor.reports.length">
          <h3 class="detail-prop-title">Reports</h3>
          <ul><li v-for="report in vendor.reports" :key="report.id" class="ti-p mb1">
              <a :href="report.url" class="ti-link">
                {{report.name}}
              </a>
          </li></ul>
        </div>
      </div> <!-- right column -->
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'VendorDetail',
  components: { },
  data() {
    return {
      loading: true, // first load of refMap
      objId: this.$route.params.id,
      vendor: null,
      error: null,
      user: null,
    };
  },

  computed: {
  },

  created() {
    const params = {};
    if (this.$store.state.refMap === null) {
      // if page loaded from URL
      params.schema = '1';
    }
    axios.get(`/api/vendors/${this.objId}`, { params })
      .then((res) => {
        if (res.data.vendor) {
          this.vendor = res.data.vendor;
          this.user = res.data.user;
          if (this.$store.state.refMap === null) {
            this.$store.commit('initMaps', res.data.refMap);
          }
        } else if (res.data.result === 'fail') {
          this.error = res.data.message;
        }
        this.loading = false;
      });
  },

  methods: {
    hasVertical(code) {
      return this.vendor.verticals.indexOf(code) !== -1;
    },
  },
};
</script>

<style>
  .vendor-role-label {
    text-align:left;
    font-weight:normal;
    border-top: 1px solid #E5E5E5;
  }
</style>
